'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var flagSources = exports.flagSources = {
  DEFAULT: 'DEFAULT',
  EXPERIMENT: 'EXPERIMENT',
  QUERY_PARAM: 'QUERY_PARAM',
  OVERRIDE: 'OVERRIDE'
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zdGFudHMuanMiXSwibmFtZXMiOlsiZmxhZ1NvdXJjZXMiLCJERUZBVUxUIiwiRVhQRVJJTUVOVCIsIlFVRVJZX1BBUkFNIiwiT1ZFUlJJREUiXSwibWFwcGluZ3MiOiI7Ozs7O0FBQU8sSUFBTUEsb0NBQWM7QUFDekJDLFdBQVMsU0FEZ0I7QUFFekJDLGNBQVksWUFGYTtBQUd6QkMsZUFBYSxhQUhZO0FBSXpCQyxZQUFVO0FBSmUsQ0FBcEIiLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IGZsYWdTb3VyY2VzID0ge1xuICBERUZBVUxUOiAnREVGQVVMVCcsXG4gIEVYUEVSSU1FTlQ6ICdFWFBFUklNRU5UJyxcbiAgUVVFUllfUEFSQU06ICdRVUVSWV9QQVJBTScsXG4gIE9WRVJSSURFOiAnT1ZFUlJJREUnLFxufVxuIl19